import { createContext, useContext, useState, useEffect } from 'react';

const API = process.env.REACT_APP_BACKEND_URL;
const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);     // null = checking, false = not auth
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('salonup_token');
    if (!token) { setUser(false); setLoading(false); return; }
    fetch(`${API}/api/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => { if (!r.ok) throw new Error(); return r.json(); })
      .then(u => setUser(u))
      .catch(() => { localStorage.removeItem('salonup_token'); setUser(false); })
      .finally(() => setLoading(false));
  }, []);

  const login = async (loginStr, password) => {
    const res = await fetch(`${API}/api/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ login: loginStr, password }),
    });
    let data = null;
    try {
      data = await res.json();
    } catch {
      data = null;
    }
    if (!res.ok) {
      throw new Error(data?.detail || data?.message || 'Erro no login');
    }
    if (!data?.token) {
      throw new Error('Resposta invalida do servidor');
    }
    localStorage.setItem('salonup_token', data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem('salonup_token');
    setUser(false);
  };

  const getToken = () => localStorage.getItem('salonup_token');

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, getToken }}>
      {children}
    </AuthContext.Provider>
  );
};
